export default {
  advisor: 'advisor',
  individual: 'individual',
  institutional: 'institutional'
};
